import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import {axios} from "@/utils";
//import support from '@/domain/support/routes'
import autologin from '@/domain/autologin/routes'

import mercado_pago from './routes/mercado_pago'
import profile from './routes/profile'
import checkout from './routes/checkout'
import homepage from './routes/homepage'
import preview from './routes/preview'
import other from './routes/other'
import help from './routes/help'
import events from './routes/events'
import live from './routes/live'
import checkin from './routes/checkin'
import login from './routes/login'
import impersonate from './domain/impersonate/routes'
import galleryTree from './domain/galleryTree/routes'

import EventService from "@/services/Event";
import {CheckinAlreadyExistForUser, NextStepRequired} from "@/domain/autologin/exceptions";


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            const headerHeight = 136
            // scroll to the anchor
            window.scrollTo({top: document.querySelector(to.hash).offsetTop - headerHeight, behavior: 'smooth'})
        } else {
            // scroll to top
            return {x: 0, y: 0}
        }
    },
    routes: [
        ...homepage,
        //...support, //new support on hold
        ...help,
        ...autologin,
        ...preview,
        ...events,
        ...live,
        ...other,
        ...login,
        ...checkin,
        ...checkout,
        ...mercado_pago,
        ...impersonate,
        ...galleryTree,
        ...profile,
        {
            path: '/checkins',
            name: 'checkins-list',
            component: () => import(/* webpackChunkName: "checkins-list" */ './views/CheckinsList.vue'),
            meta: {
                requiresAuth: true
            },
            beforeEnter: async (to, from, next) => {
                // Before entering into the view, we check if there is a picacode obtained from the query
                // or from the Preview page
                let picacode = null
                if (sessionStorage.getItem('picacode')) {
                    picacode = sessionStorage.getItem('picacode')
                    sessionStorage.removeItem('picacode')
                } else if (to.query.hasOwnProperty('picacode'))
                    picacode = to.query.picacode
                else if (store.getters['getAutoCheckinPicacode'])
                    picacode = store.getters['getAutoCheckinPicacode']

                if (picacode)
                    sessionStorage.setItem('recover_picacode', picacode)

                const source = store.getters['getAutoCheckinSource']
                const tags = store.getters['getAutoCheckinTags']
                const redirectTo = store.getters['getRedirectTo']

                store.dispatch('clearAutoCheckinState')
                if (!picacode) {
                    next()
                    return
                }

                if (redirectTo) {
                    next({name: redirectTo})
                    return
                }
                // Under the hood we create a checkin, then redirect the user to the checkins-detail route
                try {
                    await store.dispatch('checkin/createCheckin', {picacode, source, tags})
                    await router.push({name: 'checkins-detail', params: {picacode}})
                } catch (e) {
                    if (e instanceof NextStepRequired) {
                        next()
                        await store.dispatch('checkin/openStepModal')
                    } else if (e instanceof CheckinAlreadyExistForUser) {
                        await router.push({
                            name: 'checkins-detail',
                            params: {picacode: e.getPicacode()}
                        })
                    } else {
                        next()
                    }
                }
            }
        },

        {
            path: "*",
            component: () => import(/* webpackChunkName: "page-not-found" */ './views/PageNotFound.vue')
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    const isAuthenticated = store.getters['auth/isAuthenticated']
    const currentUser = store.getters['auth/currentUser']
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const requiresNotAuth = to.matched.some(record => record.meta.requiresNotAuth)

    // ------ APP CONFIG -----//
    // if is third level domain we get the app configuration (only if is the first url called)
    if (!store.getters['isPicaThirdLevelDomain'] && !store.state.appConfig.appConfigReady) {
        try {
            let response = await store.dispatch('appConfig/getConfig', {appName: store.state.thirdLevelDomain})
            localStorage.setItem('eventOwnerId', response.data.id)
            axios.defaults.headers.common['pica-event-owner-id'] = response.data.id

        } catch (error) {
            localStorage.removeItem('eventOwnerId')
        }
    } else {
        store.commit('appConfig/SET_APP_CONFIG_READY')
        localStorage.removeItem('eventOwnerId')
    }
    // ---- END APP CONFIG ----//

    // Check if the route requires authentication
    if (requiresAuth) {
        // If user data is not available, fetch the current user
        if (!currentUser) {
            await store.dispatch('auth/getCurrentUser')
        }

        // If the route is not the 'terms' page and privacy policies are not accepted,
        // redirect to the 'terms' page
        if (to.name !== 'terms' && !store.getters['auth/hasAcceptedRequiredPolicies']) {
            next({name: 'terms', params: {next: to.name}})
        } else {
            // If the user is authenticated, proceed to the requested route; otherwise, redirect to '/'
            isAuthenticated ? next() : next('/')
        }
    }
    // Check if the route does not require authentication
    else if (requiresNotAuth) {
        // If the user is authenticated, redirect to '/'
        isAuthenticated ? next('/') : next()
    }
    // If the route neither requires nor prohibits authentication, proceed to the requested route
    else {
        next()
    }

    // Redirect to the www subdomain if the user is in the mypic subdomain
    const url = location.href;
    if (url.includes('mypic.')) {
        location.replace(url.replace('mypic.', 'www.'))
    }
})

export default router
